
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colaboradores",
      function () {
        return require("private-next-pages/colaboradores/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colaboradores"])
      });
    }
  